module.exports = __webpack_public_path__ + "static/media/map-desktop.68cd69a3.png";